import { useNavigate } from "react-router-dom";
import { accessToken, role } from "../utils/localData";
import {
  selectGeneral,
  setCreateProjectAfterLogin,
  setShowAuthModal,
  setShowWalletRequiredModal,
} from "../redux/slices/generalSlice";
import { useDispatch, useSelector } from "react-redux";
import { UN_REGISTERED } from "../Constants";
import {
  setRegisterModalType,
  setShowRegisterModal,
} from "../redux/slices/generalSlice";
import { useGetUserQuery } from "../redux/slices/api/userApi";
import notify from "../components/common/notify";
import useWalletAuth from "./useWalletAuth";

// Custom hook to handle project creation
const useHandleCreateProject = () => {
  const navigate = useNavigate(); // Hook for navigation
  const { isLoggedIn } = useSelector(selectGeneral); // Redux state for login status

  // Query to get user data
  const { isLoading: meLoading, data: meData } = useGetUserQuery(null, {
    skip: !isLoggedIn,
  });

  // Auth hook for wallet status - use creator-specific method
  const { ensureWalletReadyForCreator, isLoading: isConnecting } = useWalletAuth();
  const dispatch = useDispatch();

  // Function to handle project creation
  const handleCreateProject = async () => {
    console.log("🚀 handleCreateProject called", {
      isConnecting,
      meLoading,
      isLoggedIn,
      meData: meData?.user,
      role: role(),
      hasToken: !!accessToken()
    });

    if (!isConnecting && !meLoading) {
      // Check if user email is verified (only if logged in)
      if (isLoggedIn && meData && !meData?.user?.email_verified) {
        console.log("❌ Email not verified");
        notify("Please verify your email first!", "error");
        return;
      }

      // Check if user has unfinished profile
      if (accessToken() && role() === UN_REGISTERED) {
        console.log("❌ User has unfinished profile");
        dispatch(setRegisterModalType("signupBtn"));
        dispatch(setShowRegisterModal(true));
        return;
      }

      console.log("🔍 Checking wallet readiness for creator...");
      // Use the creator-specific wallet check
      // This ensures user has profile AND linked wallet
      const { ready, reason } = await ensureWalletReadyForCreator(
        'create a fundraising project',
        "/create-project?new=true"
      );

      console.log("📊 Wallet check result:", { ready, reason });

      if (!ready) {
        // Modal will be shown by ensureWalletReadyForCreator
        dispatch(setCreateProjectAfterLogin(true));
        console.log("⚠️ Wallet not ready, modal should be shown. Reason:", reason);
        return;
      }

      // All checks passed - navigate to create project
      console.log("✅ All checks passed, navigating to create project...");
      navigate("/create-project?new=true");
    } else {
      console.log("⏳ Still connecting or loading:", { isConnecting, meLoading });
    }
  };

  return { handleCreateProject };
};

export default useHandleCreateProject;
